<h1 mat-dialog-title>Alert</h1>
<div mat-dialog-content>
  <p>Are you sure want add these Geo Fencing for {{data.regNo}}?</p>
</div>
<div mat-dialog-actions>
  <button mat-button matDialogClose="false">No, Cancel</button>
  <button mat-button matDialogClose="true" cdkFocusInitial>Yes</button>
</div>
